<template>
    <Modal :title="t({ key: 'price_guarantee.modal.title' })" size="l">
        <div>
            <p>
                {{ t({ key: 'price_guarantee.modal.paragraph_1', suffix: ':' }) }}
            </p>
            <ul>
                <li v-for="item in 3" :key="item">
                    {{ t({ key: `price_guarantee.modal.list_item_${item}` }) }}
                </li>
            </ul>
            <p>
                {{ t({ key: 'price_guarantee.modal.paragraph_2' }) }}
            </p>
        </div>
    </Modal>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import Modal from '@ui/components/Modal/Modal.vue';
    import { t } from '@shared/helpers/translation';

    export default defineComponent({
        name: 'PriceGuaranteeModal',
        methods: { t },
        components: { Modal },
    });
</script>

<style lang="scss" scoped>
    ul {
        margin-bottom: var(--spacing-16);
    }
</style>
